// extracted by mini-css-extract-plugin
export var container = "_8o-0";
export var icon = "_8o-1";
export var text = "_8o-2";